import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormPassword from '../../components/form/FormPassword/FormPassword';

const FormPasswordContainer = props =>
  <Field
    name={props.name}
    component={FormPassword}
    props={props}
  />
;

FormPasswordContainer.propTypes = {
  name: PropTypes.string
};

export default FormPasswordContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/FormPasswordContainer.js
 **/